var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "b-row",
        { staticClass: "section-invert", attrs: { id: "discounts" } },
        [
          _c(
            "b-col",
            { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("discounts.title")))]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-info",
                domProps: { innerHTML: _vm._s(_vm.$t("discounts.subtitle")) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c(
                  "div",
                  { staticClass: "subtitle-list subtitle-list mt-sm-5" },
                  [
                    _c("div", [
                      _c(
                        "p",
                        [
                          _c("v-icon", {
                            attrs: { large: "" },
                            domProps: { textContent: _vm._s("mdi-heart-pulse") }
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("discounts.clinic-services")) +
                              "\n              "
                          ),
                          _c("v-icon", {
                            domProps: {
                              textContent: _vm._s("mdi-chevron-down")
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.dialog1 = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "p",
                        [
                          _c("v-icon", {
                            attrs: { large: "" },
                            domProps: {
                              textContent: _vm._s("mdi-tooth-outline")
                            }
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("price-cards.tooth-services")) +
                              "\n              "
                          ),
                          _c("v-icon", {
                            domProps: {
                              textContent: _vm._s("mdi-chevron-down")
                            },
                            on: {
                              click: function($event) {
                                _vm.dialog2 = !_vm.dialog2
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "p",
                        [
                          _c("v-icon", {
                            attrs: { large: "" },
                            domProps: { textContent: _vm._s("mdi-spa-outline") }
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("price-cards.wellness-services")) +
                              "\n              "
                          ),
                          _c("v-icon", {
                            domProps: {
                              textContent: _vm._s("mdi-chevron-down")
                            },
                            on: {
                              click: function($event) {
                                _vm.dialog3 = !_vm.dialog3
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "btn-more-info-white",
                  staticStyle: { color: "white" },
                  attrs: {
                    white: "",
                    outline: "",
                    href: "/opensaludprime/descuentos"
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v(_vm._s(_vm.$t("more-info-btn")))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "12", lg: "6" } }, [
            _c("div", { staticClass: "col-bg ml-lg-auto" })
          ]),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { width: "auto" },
              model: {
                value: _vm.dialog1,
                callback: function($$v) {
                  _vm.dialog1 = $$v
                },
                expression: "dialog1"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("discounts.clinic-services-description")
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c(
                      "ul",
                      { staticClass: "column_wrapper mt-4" },
                      _vm._l(_vm.medical_services, function(data, i) {
                        return _c("li", { key: i }, [
                          _vm._v(
                            "\n              " + _vm._s(data) + "\n            "
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog1 = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("discounts.close")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              model: {
                value: _vm.dialog2,
                callback: function($$v) {
                  _vm.dialog2 = $$v
                },
                expression: "dialog2"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("discounts.teeth-services-description")) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c(
                      "ul",
                      { staticClass: "column_wrapper mt-4" },
                      _vm._l(_vm.teeth_services, function(data, i) {
                        return _c("li", { key: i }, [
                          _vm._v(
                            "\n              " + _vm._s(data) + "\n            "
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog2 = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("discounts.close")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              model: {
                value: _vm.dialog3,
                callback: function($$v) {
                  _vm.dialog3 = $$v
                },
                expression: "dialog3"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("discounts.health-services-description")
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c(
                      "ul",
                      { staticClass: "column_wrapper" },
                      _vm._l(_vm.health_services, function(data, i) {
                        return _c("li", { key: i }, [
                          _vm._v(
                            "\n              " + _vm._s(data) + "\n            "
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog3 = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("discounts.close")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ce4daf5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce4daf5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/OpenSaludDiscounts.vue
// module id = 3224
// module chunks = 36 37